import React from "react";
import { cn } from "@/lib/utils";
import { Skeleton } from "@/components/ui/skeleton";

export default function ProductCardSkeletonLoader({ size = "md" }: { size: "sm" | "md" | "lg" }) {
  return (
    <div
      className={cn(
        "group relative flex w-full flex-col rounded-t-lg p-0 md:overflow-hidden",
        size === "sm" ? "h-[22rem]" : size === "md" ? "h-[300px] md:h-[360px]" : "h-[650px]"
      )}
    >
      <div
        className={cn(
          "relative w-full rounded-lg",
          size === "sm" ? "h-[18.5rem]" : size === "md" ? "h-2/3 md:h-2/3" : "h-[40rem]"
        )}
      >
        <Skeleton className='size-full' />
      </div>
      <div className='flex flex-1 flex-col pt-2 md:pt-4'>
        <div className='flex h-full flex-col justify-between'>
          <Skeleton className='h-4 w-2/3' />
          <div className='flex items-center gap-[30%]'>
            <Skeleton className='hidden h-4 flex-1 md:block' />
            <Skeleton className='h-4 max-w-[60%] flex-1' />
          </div>
          <div className='flex items-center gap-4'>
            <Skeleton className='h-4 flex-1 rounded-full py-4 md:py-6' />
          </div>
        </div>
      </div>
    </div>
  );
}
